import * as React from 'react';
const SvgBrandGuidelines = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M32.971 91.029V79.416h54.192v42.579H32.97"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m31.036 110.383 17.419-15.484 17.418 17.419"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m62.002 108.447 7.742-7.741 17.419 17.418M75.55 92.964a1.935 1.935 0 1 0 0-3.87 1.935 1.935 0 0 0 0 3.87ZM98.775 118.124h21.285c1.069 0 1.94-.866 1.94-1.935V52.321L98.775 31.03H63.938c-1.07 0-1.936.866-1.936 1.935v34.838"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M122 52.32h-19.354a1.935 1.935 0 0 1-1.935-1.935v-3.87M79.421 65.868h25.16M98.775 79.416h5.806M31.578 67.804a31.046 31.046 0 0 1-.542-5.806c0-12.997 8.008-24.12 19.354-28.717"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.904 30.523a3.873 3.873 0 0 0 0-5.472L98.954 14.1a3.872 3.872 0 0 0-5.472 0l-1.926 1.926a3.868 3.868 0 0 1-4.22.837l-11.33-4.693a3.874 3.874 0 0 1-2.391-3.576V5.87A3.87 3.87 0 0 0 69.744 2H54.261a3.87 3.87 0 0 0-3.871 3.87v2.725A3.87 3.87 0 0 1 48 12.17l-11.332 4.693a3.877 3.877 0 0 1-4.22-.837L30.524 14.1a3.872 3.872 0 0 0-5.472 0L14.1 25.051a3.872 3.872 0 0 0 0 5.472l1.926 1.926a3.868 3.868 0 0 1 .837 4.219L12.17 48a3.874 3.874 0 0 1-3.576 2.39H5.87A3.87 3.87 0 0 0 2 54.26v15.484a3.87 3.87 0 0 0 3.87 3.87h2.725a3.87 3.87 0 0 1 3.576 2.391l4.693 11.332a3.877 3.877 0 0 1-.837 4.22L14.1 93.481a3.872 3.872 0 0 0 0 5.472l10.95 10.95c1.51 1.509 4.47 1.998 5.985.484"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgBrandGuidelines;
